module.exports = __webpack_public_path__ + "img/perCapital-dark.9ea2adb6.png";